import {Component} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-delete-card-success-dialog',
  templateUrl: './delete-card-success-dialog.component.html',
  styleUrls: ['./delete-card-success-dialog.component.scss']
})
export class DeleteCardSuccessDialogComponent {
  constructor(
    private modalService: ModalService,
    private router: Router
  ) {
  }

  closeModal() {
    this.modalService.closeModal()
  }

  goToRoleList() {
    this.closeModal()
    this.router.navigate(['/saved-card-list'])
  }
}
